/**
 * @format
 * @flow
 */
import {
    LOGGED_IN,
    LOGGED_OUT,
    RESET,
    SIGNED_UP,
    UPDATED_USER
} from "../actions/User";

const initialState = {
    isLoggedIn: false,
    isSignedUp: false,
    enterpriseId: null,
    enterpriseName: null,
    enterprisePhotoId: null,
    enterpriseCategory: null,
    description: null,
    lineCd: null,
    stationCd: null,
    way: null,
    workTime: null,
    locDescription: null,
    temporaryPassword: null,
    phone: null,
    email: null,
    emailVerified: false,
    postalCode: null,
    prefecture: null,
    municipality: null,
    street: null,
    createDate: null,
    updateDate: null,
    deleteFlag: false,
    accessToken: null,
    idToken: null,
    refreshToken: null,
    lastLoginDate: null,
    coordinate: [], // 地図
    lastChangedAt: new Date().getTime()
};

function user(state = initialState, action) {
    if (action.type === SIGNED_UP) {
        return { ...state, isSignedUp: true };
    }
    if (action.type === LOGGED_IN || action.type === UPDATED_USER) {
        const {
            enterpriseId,
            enterpriseName,
            enterprisePhotoId,
            enterpriseCategory,
            description,
            lineCd,
            stationCd,
            way,
            workTime,
            locDescription,
            temporaryPassword,
            phone,
            email,
            emailVerified,
            postalCode,
            prefecture,
            municipality,
            street,
            createDate,
            updateDate,
            deleteFlag,
            accessToken,
            idToken,
            refreshToken,
            lastLoginDate,
            coordinate // 地図
        } = action.data;

        const result = {
            isLoggedIn: true,
            isSignedUp: true,
            enterpriseId,
            enterpriseName,
            enterprisePhotoId,
            enterpriseCategory,
            description,
            lineCd,
            stationCd,
            way,
            workTime,
            locDescription,
            temporaryPassword,
            phone,
            email,
            emailVerified,
            postalCode,
            prefecture,
            municipality,
            street,
            createDate,
            updateDate,
            deleteFlag,
            accessToken,
            idToken,
            refreshToken,
            lastLoginDate,
            coordinate,
            lastChangedAt: new Date().getTime()
        };

        return result;
    }
    if (action.type === RESET || action.type === LOGGED_OUT) {
        return initialState;
    }
    return state;
}

export default user;
// module.exports = user;
